import axios from 'axios';

export default {
    fetchStats() {
        return axios.get('https://hrv.insec.org.np/api/v1/hrv-stats');
    }
}